import SearchService from '@/services/search'
import MPService from '@/services/mixpanel'
import highlights from '@/mixins/highlights'

export default {
  mixins: [highlights],
  props: {
    slug: {
      type: String,
      required: false,
      default: ''
    }
  },
  data () {
    return {
      error: '',
      isLoaded: false,
      isError404: false,
      scope: '',
      data: {}
    }
  },
  computed: {
    slugFromQuery () {
      return this.$route.query[this.scope]
    },
    getScope () {
      return this.$options.filters.pluralize(this.scope, 2)
    }
  },
  mounted () {
    !this.slugFromQuery && !this.slug ? this.isError404 = true : this.fetch(this.slugFromQuery)

    this.$events.$on('bookmark_folder:bookmark:modal', (bookmarkFolders) => {
      this.$set(this.data, 'bookmark_folders', bookmarkFolders)
    })
  },
  watch: {
    slugFromQuery (newSlug, oldSlug) {
      if (this.isEmpty(newSlug)) this.closeModal()
    },
    isLoaded (newValue, oldValue) {
      if (newValue && newValue !== oldValue) MPService.trackModalOpened(this.scope)
    }
  },
  methods: {
    fetchHighlights (index, slug) {
      SearchService.highlightsDetailView(this.getSearchQueryForHighlighting(index, this.data.slug_values, this.$route.query.keyword)).then(highlights => {
        const parsedHighlights = this.generateHighlights(this.data, highlights, this.objectForHighlighting)
        this.$set(this.data, 'highlights', parsedHighlights)
        this.isLoaded = true
      }).catch(err => {
        this.error = this.handleError(err)
      })
    },
    updateHighlights () {
      const parsedHighlights = this.regenerateHighlights(this.data, this.objectForHighlighting)
      this.$set(this.data, 'highlights', parsedHighlights)
    },
    handleCustomError (err) {
      if (err.status === 404) {
        this.isError404 = this.isLoaded = true
      } else {
        this.error = this.handleError(err)
        this.isLoaded = !this.isEmpty(this.error)
      }
    },
    closeModal () {
      this.$events.$emit('modal:close')
    }
  },
  beforeDestroy () {
    if (!this.isEmpty(this.$route.query[this.scope])) {
      let queryObj = Object.assign({}, this.$route.query)
      delete queryObj[this.scope]
      delete queryObj.hr // Clear "human readable" slug_text from URL when closing search result modal
      this.$route.meta.searchContainer || this.$route.meta.searchModal ? this.$router.push({ query: queryObj }) : this.$router.replace({ query: queryObj })
    }
  },
  destroyed () {
    this.$events.$off('bookmark_folder:bookmark:modal')
  }
}
